// extracted by mini-css-extract-plugin
module.exports = {"root":"Title_root__3X7Z_"};